import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

/** Contenitore dei toast, montato una volta sola in App (fisso in basso a destra, sopra tutto). */
@Component({
  selector: 'app-toast-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed bottom-4 right-4 z-[1200] flex flex-col gap-2 w-full max-w-sm pointer-events-none">
      @for (t of toasts.toasts(); track t.id) {
        <div
          class="pointer-events-auto flex items-start gap-2.5 rounded-lg border px-4 py-3 text-sm shadow-lg animate-[toast-in_.18s_ease-out]"
          [class]="t.kind === 'success'
            ? 'bg-emerald-600 border-emerald-700 text-white'
            : 'bg-red-600 border-red-700 text-white'"
          role="status"
        >
          <span class="material-icons mat-icon-sm mt-0.5">{{ t.kind === 'success' ? 'check_circle' : 'error' }}</span>
          <span class="flex-1">{{ t.message }}</span>
          <button type="button" class="opacity-80 hover:opacity-100" (click)="toasts.dismiss(t.id)" aria-label="Chiudi">
            <span class="material-icons mat-icon-sm">close</span>
          </button>
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes toast-in { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
  `],
})
export class ToastHost {
  protected readonly toasts = inject(ToastService);
}
